<template>
  <div style="
      background: url('https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704181755475.jpg');
      background-size: 100% 100%;
    ">
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="">
          <div class="title-img">
            <div class="title">设备统计</div>
          </div>
          <div class="state-bg">
            <div class="data-count">
              <div class="data-sum-count">
                <div class="box_sum">
                  <p>{{ onlineNum + offlineNum }}</p>
                </div>
              </div>
              <div class="data-sum-count" style="margin-left: 15px">
                <div>
                  <div class="box_online">
                    <p>在线设备</p>
                    <b>{{ onlineNum }}</b>
                  </div>
                  <div class="box_online">
                    <p>离线设备</p>
                    <b>{{ offlineNum }}</b>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="title-img">
            <div class="title">设备列表</div>
            <div class="title-img-tab">
              <div id="title-img-tab1" @click="changDevice(0)">水肥一体机</div>
              <div id="title-img-tab2" @click="changDevice(1)">智慧灌溉</div>
            </div>
          </div>
          <div class="list-bg">
            <div class="" style="
                margin: 0 15px 0px 20px;
                background: rgba(176, 218, 239, 0.15);
                padding-left: 15px;
              ">
              <el-row>
                <el-col :span="9">
                  <div class="">设备名称</div>
                </el-col>
                <el-col :span="4">
                  <div class="">设备状态</div>
                </el-col>
                <el-col :span="6">
                  <div class=""></div>
                  所在园区
                </el-col>
                <el-col :span="5">
                  <div class="">设备类型</div>
                </el-col>
              </el-row>
            </div>
            <div v-if="waterType == 0">
              <div v-if="fertilizerDeviceList.length != 0" class="water-list-body-item">
                <div @click="optForFertilizerDeviceList(item)" v-for="(item, index) in fertilizerDeviceList"
                  :key="index">
                  <el-row style="padding: 20px 8px" :class="fertilizerDeviceListOptFor == item
                    ? 'water-list-body-item-bg'
                    : ''
                    ">
                    <el-col :span="9">
                      <div class="" style="margin-left: 15px">
                        {{ item.fertilizerDeviceName }}
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="" style="text-align: center">
                        {{ item.fertilizerDeviceState == 2 ? "在线" : "离线" }}
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class=""></div>
                      {{ item.massifName ? item.massifName : "暂未分配" }}
                    </el-col>
                    <el-col :span="5">
                      <div style="text-align: center">
                        {{
                          item.fertilizerDeviceType == 1 ? "单通道" : "四通道"
                        }}
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div v-else style="margin-top: 100px">
                <el-empty :image-size="75" description="暂无设备"
                  image="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1705376475598.png"></el-empty>
              </div>
            </div>
            <div v-if="waterType == 1">
              <div v-if="remoteDeviceList.length != 0" class="water-list-body-item">
                <div @click="optForRemoteDeviceList(item)" v-for="(item, index) in remoteDeviceList" :key="index">
                  <el-row :class="remoteDeviceListOptFor == item
                    ? 'water-list-body-item-bg'
                    : ''
                    ">
                    <el-col :span="9">
                      <div class="" style="margin-left: 15px">
                        {{ item.remoteDeviceName }}
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="" style="text-align: center">
                        {{ item.remoteDeviceState == 2 ? "在线" : "离线" }}
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class=""></div>
                      {{ item.massifName ? item.massifName : "暂未分配" }}
                    </el-col>
                    <el-col :span="5">
                      <div style="text-align: center">
                        T2
                        <!-- {{ item.remoteDeviceType == 0 ? "四通道" : "单通道" }} -->
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div v-else style="margin-top: 100px">
                <el-empty :image-size="75" description="暂无设备"
                  image="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1705376475598.png"></el-empty>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="18" v-if="waterType == 0">
        <div class="" style="display: flex; justify-content: space-between; height: 390px">
          <div class="center-top-img">
            <!--  -->
            <div class="" id="div" style="
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #294375;
                border-radius: 10px;
                overflow: hidden;
              ">
              <!--  left: 75px; -->
              <oneAisle style="width: 93%; height: 100%; position: relative"
                :fertilizerDeviceListOptFor="fertilizerDeviceListOptFor"
                v-if="fertilizerDeviceListOptFor.fertilizerDeviceType == '1'" @loadingEvent="loadingEvent"
                @sonDataList="newDataList"></oneAisle>

              <!--  left: 35px; -->
              <fourAisle style="width: 100%; height: 100%; position: relative"
                :fertilizerDeviceListOptFor="fertilizerDeviceListOptFor"
                v-if="fertilizerDeviceListOptFor.fertilizerDeviceType == '0' || fertilizerDeviceListOptFor.fertilizerDeviceType == '3'"
                @loadingEvent="loadingEvent" @sonDataList="newDataList"></fourAisle>
            </div>

          </div>
          <div class="center-top-list">
            <div class="">
              <ul>
                <li>
                  <b>{{ oneList[0] }}</b>
                  <p>土壤湿度</p>
                  <span>单位：%RH</span>
                </li>
                <li style="margin-top: 40px">
                  <b>{{ oneList[1] }}</b>
                  <p>土壤温度</p>
                  <span>单位：℃</span>
                </li>
              </ul>
            </div>
            <div class="">
              <ul>
                <li>
                  <b>{{ oneList[2] }}</b>
                  <p>溶液EC值</p>
                  <span>单位：µS/cm</span>
                </li>
                <li style="margin-top: 40px">
                  <b>{{ oneList[3] }}</b>
                  <p>溶液PH值</p>
                </li>
              </ul>
            </div>
            <div class="">
              <ul>
                <li>
                  <b>{{ fourList[0] }}</b>
                  <p>主管压力</p>
                  <span>单位：Mpa</span>
                </li>
                <li style="margin-top: 40px">
                  <b>{{ fourList[1] }}</b>
                  <p>总流量</p>
                  <span>单位：m³</span>
                </li>
              </ul>
            </div>
            <div class="">
              <ul>
                <li>
                  <b>{{ fourList[2] }}</b>
                  <p>瞬时流量</p>
                  <span>单位：L/S</span>
                </li>
                <li style="margin-top: 40px">
                  <b>{{ fourList[3] }}</b>
                  <p>溶液温度</p>
                  <span>单位：℃</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="">
          <div class="">
            <div class="chart-title">
              <div class="title1-img">
                <div class="titles">{{ powerInfo ? powerInfo.powerWaterRegion1Name : '土壤温湿度' }}</div>
              </div>
              <div class="title1-img">
                <div class="titles">{{ powerInfo ? powerInfo.powerWaterRegion2Name : 'EC值' }}</div>
              </div>
            </div>
            <div class="center-chart1">
              <div class="chart-bg">
                <div id="main1" style="padding: 0px; width: 100%; height: 230px"></div>
              </div>
              <div class="chart-bg">
                <div class="" id="main2" style="
                    padding: 0px;
                    width: 100%;
                    height: 240px;
                    margin-top: -15px;
                  "></div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="chart-title">
              <div class="title1-img">
                <div class="titles">{{ powerInfo ? powerInfo.powerWaterRegion3Name : 'PH值' }}</div>
              </div>
              <div class="title1-img">
                <div class="titles"> {{ powerInfo ? powerInfo.powerWaterRegion4Name : '水压力值' }}</div>
              </div>
            </div>
            <div class="center-chart1">
              <div class="chart-bg">
                <div id="main3" style="
                    padding: 0px;
                    width: 100%;
                    height: 250px;
                    margin-top: -30px;
                  "></div>
              </div>
              <div class="chart-bg">
                <div class="" id="main4" style="
                    padding: 0px;
                    width: 100%;
                    height: 250px;
                    margin-top: -30px;
                  "></div>
              </div>
            </div>
          </div>
        </div>
      </el-col>

      <el-col :span="18" v-if="waterType == 1">
        <waters :remoteDeviceListOptFor="remoteDeviceListOptFor" @loadingEvent="loadingEvent"></waters>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from "echarts";
import oneAisle from "./oneAisle.vue";
import fourAisle from "./fourAisle.vue";
import waters from "./waters.vue";
export default {
  name: "app",
  components: {
    oneAisle,
    fourAisle,
    waters,
  },
  props: {
    // 当前活动tab的索引
    parkId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fertilizerDeviceList: [],
      onlineNum: 0,
      offlineNum: 0,
      nowTime: "",
      fertilizerDeviceListOptFor: "",
      aisleType: "0",
      aisleData: [],
      loadingType: false,
      userInfo: {},
      waterType: 0,
      oneList: [0, 0, 0, 0],
      twoList: [0, 0, 0, 0],
      threeList: [0, 0, 0, 0],
      fourList: [0, 0, 0, 0],
      remoteDeviceListOptFor: {},
      remoteDeviceList: [],
      powerInfo: {}
    };
  },
  async mounted() {
    console.log("mounted===this.parkId", this.parkId);

    // 从本地缓存中获取数据
    let userInfo = localStorage.getItem("user_info");
    // 将获取到的JSON字符串转换回对象
    this.userInfo = JSON.parse(userInfo);
    let powerInfo = localStorage.getItem("power_info");
    this.powerInfo = JSON.parse(powerInfo);
    console.log("mounted===this.powerInfo", this.powerInfo);



    // console.log("info===", this.userInfo);
    // var dom1 = document.getElementById("main1");
    // var myChart1 = echarts.init(dom1, null, {
    //   renderer: "canvas",
    //   useDirtyRect: false,
    // });
    // var option;

    // option = {
    //   tooltip: {
    //     trigger: "axis",
    //   },
    //   color: "rgba(83, 203, 255, 0.92)",
    //   calculable: true,
    //   xAxis: [
    //     {
    //       type: "category",
    //       // prettier-ignore
    //       data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    //     },
    //   ],
    //   yAxis: [
    //     {
    //       type: "value",
    //     },
    //   ],
    //   series: [
    //     {
    //       name: "Evaporation",
    //       type: "bar",
    //       data: [0, 0, 0, 0, 0, 0, 0],
    //       markPoint: {
    //         data: [
    //           {
    //             name: "Max",
    //             value: 182.2,
    //             xAxis: 7,
    //             yAxis: 183,
    //           },
    //           {
    //             name: "Min",
    //             value: 2.3,
    //             xAxis: 11,
    //             yAxis: 3,
    //           },
    //         ],
    //       },
    //     },
    //   ],
    // };

    // if (option && typeof option === "object") {
    //   myChart1.setOption(option);
    // }
    // window.addEventListener("resize", myChart1.resize);

    let currentDate = new Date();
    let year = currentDate.getFullYear();
    let month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); //月份是从0开始计数的，所以要加1
    let day = currentDate.getDate().toString().padStart(2, "0");
    let hour = currentDate.getHours().toString().padStart(2, "0");
    let minute = currentDate.getMinutes().toString().padStart(2, "0");
    let formattedDate = `${year}-${month}-${day} ${hour}:${minute}`;

    // let formattedDate = `${year}-${month}-${day}`;
    this.nowTime = this.getNextDay(formattedDate);
    // this.nowTime = "2025-05-17";
    console.log("nowTime===", this.nowTime);

    await this.getFertilizerDevice();
    // await this.getFiveEchart();
    // await this.getOneEchart();
    // await this.getTwoEchart();
    // await this.setSVGViewBox();
    // window.addEventListener('resize', this.setSVGViewBox)
  },
  methods: {
    newDataList(res) {
      console.log("================dataList", res);
      // this.newDataList = res;
      for (let i in res) {
        /* 1 */
        if (res[i].pointVue === "0000") {
          //土壤1温度
          console.log("土壤1温度---res[i]", res[i]);
          this.oneList[0] = res[i].result;
        }
        if (res[i].pointVue === "0002") {
          //土壤1湿度
          console.log("土壤1湿度---res[i]", res[i]);
          this.oneList[1] = res[i].result;
        }
        if (res[i].pointVue === "0012") {
          //溶液1EC
          console.log("溶液1EC---res[i]", res[i]);
          this.oneList[2] = res[i].result;
        }
        if (res[i].pointVue === "0010") {
          //溶液1PH
          console.log("溶液1PH---res[i]", res[i]);
          this.oneList[3] = res[i].result;
        }
        /* 2 */
        if (res[i].pointVue === "0042") {
          //施肥A瞬时流量
          console.log("施肥A瞬时流量---res[i]", res[i]);
          this.twoList[0] = res[i].result;
        }
        if (res[i].pointVue === "0044") {
          //施肥B瞬时流量
          console.log("施肥B瞬时流量---res[i]", res[i]);
          this.twoList[1] = res[i].result;
        }
        if (res[i].pointVue === "0046") {
          //施肥C瞬时流量
          console.log("施肥C瞬时流量---res[i]", res[i]);
          this.twoList[2] = res[i].result;
        }
        if (res[i].pointVue === "0048") {
          //施肥D瞬时流量
          console.log("施肥D瞬时流量---res[i]", res[i]);
          this.twoList[3] = res[i].result;
        }
        /* 3 */
        if (res[i].pointVue === "004A") {
          //施肥A总流量
          console.log("施肥A总流量---res[i]", res[i]);
          this.threeList[0] = res[i].result;
        }
        if (res[i].pointVue === "004C") {
          //施肥B总流量
          console.log("施肥B总流量---res[i]", res[i]);
          this.threeList[1] = res[i].result;
        }
        if (res[i].pointVue === "004E") {
          //施肥C总流量
          console.log("施肥C总流量---res[i]", res[i]);
          this.threeList[2] = res[i].result;
        }
        if (res[i].pointVue === "0050") {
          //施肥D总流量
          console.log("施肥D总流量---res[i]", res[i]);
          this.threeList[3] = res[i].result;
        }
        /* 4 */
        if (res[i].pointVue === "0040") {
          //总管压力
          console.log("总管压力---res[i]", res[i]);
          this.fourList[0] = res[i].result;
        }
        if (res[i].pointVue === "0052") {
          //供水总流量
          console.log("供水总流量---res[i]", res[i]);
          this.fourList[1] = res[i].result;
        }
        if (res[i].pointVue === "0054") {
          //供水瞬时流量
          console.log("供水瞬时流量---res[i]", res[i]);
          this.fourList[2] = res[i].result;
        }
        if (res[i].pointVue === "0014") {
          //溶液1温度
          console.log("溶液1温度---res[i]", res[i]);
          this.fourList[3] = res[i].result;
        }
      }
      this.$forceUpdate();
    },
    loadingEvent(loadingType) {
      console.log("================", loadingType);
      this.loadingType = loadingType;
    },
    async optForFertilizerDeviceList(item) {
      if (item.fertilizerDeviceState == 2) {
        if (this.loadingType) {
          this.$message({
            message: "数据加载中，请稍后尝试！",
            type: "warning",
          });
          return;
        }

        this.fertilizerDeviceListOptFor = item;
        this.$forceUpdate();
        if (this.waterType == 0) {
          this.getFiveEchart();
          this.getOneEchart();
          this.getTwoEchart();
          this.oneList = [0, 0, 0, 0];
          this.twoList = [0, 0, 0, 0];
          this.threeList = [0, 0, 0, 0];
          this.fourList = [0, 0, 0, 0];
        }
      }
    },
    setSVGViewBox() {
      var divElement = document.getElementById("div");
      var svgElement = document.getElementById("svg");
      var divWidth = divElement.offsetWidth;
      var divHeight = divElement.offsetHeight;
      console.log("divWidth", divWidth);
      console.log("divHeight", divHeight);
      // var magnification = 0;
      var viewBoxWidth = 770;
      var viewBoxHeight = 770;
      var divAspectRatio = divWidth / divHeight;
      var viewBoxAspectRatio = viewBoxWidth / viewBoxHeight;
      var diff = "";
      if (divAspectRatio > viewBoxAspectRatio) {
        diff = (divWidth - divHeight * viewBoxAspectRatio) / 2;
        console.log("diff", diff);
        svgElement.setAttribute(
          "viewBox",
          diff + " 0 " + (viewBoxWidth + diff) + " " + viewBoxHeight
        );
      } else {
        diff = (divHeight - divWidth / viewBoxAspectRatio) / 2;
        svgElement.setAttribute(
          "viewBox",
          "0 " + diff + " " + viewBoxWidth + " " + (viewBoxHeight + diff)
        );
      }
    },
    changDevice(type) {
      console.log("切换设备列表type", type);
      //切换设备列表
      let div = document.querySelector("#title-img-tab1");
      let div1 = document.querySelector("#title-img-tab2");
      if (type == 0) {
        div.style.background = "#2C83EF";
        div1.style.background = "transparent";
        let httpData = {
          deviceId: this.fertilizerDeviceListOptFor.fertilizerDeviceNumber,
        };
        console.log("clearQueue-清空后重查---httpData", httpData);
        this.$axios
          .post("/DeviceMqttPushApi/clearQueue", {
            params: httpData,
          })
          .then((res) => {
            console.log("clearQueue-清空后重查---", res);
            this.getFertilizerDevice();
          })
          .catch((error) => {
            console.log("clearQueue-error---", error);
            // uni.hideLoading();
          });
        this.waterType = 0;
        this.fertilizerDeviceList = [];
        this.getFertilizerDevice();
        // this.getFiveEchart();
        // this.getOneEchart();
        // this.getTwoEchart();
      } else {
        div1.style.background = "#2C83EF";
        div.style.background = "transparent";
        this.waterType = 1;
        this.fertilizerDeviceList = [];
        this.getRemoteDeviceList();
      }
    },
    getRemoteDeviceList() {
      this.onlineNum = 0;
      this.offlineNum = 0;
      let httpData = {
        remoteType: 3, //设备类型（0远程控制器 1智慧灌溉 2智慧球阀 3正蝶球阀)
        deptId: this.userInfo ? this.userInfo.deptId : 0,
      };
      this.$axios
        .get("/remoteDevice/list", {
          params: httpData,
        })
        .then((data) => {
          console.log("remoteDevice/list-data", data);
          let res = data.data;
          for (let i in res) {
            if (res[i].remoteDeviceState != 2) {
              this.offlineNum += 1;
            } else {
              this.onlineNum += 1;
            }
            this.remoteDeviceList.push(res[i]);
          }
          if (this.remoteDeviceList.length != 0) {
            for (let i in this.remoteDeviceList) {
              if (this.remoteDeviceList[i].remoteDeviceState == 2) {
                this.remoteDeviceListOptFor = this.remoteDeviceList[i];
                break;
              }
            }
          }
        })
        .catch((error) => {
          console.log("remoteDevice/list--error", error);
        });
    },
    optForRemoteDeviceList(item) {
      if (item.remoteDeviceState == 2) {
        // if (this.loadingType) {
        // 	this.$message({
        // 		message: "数据加载中，请稍后尝试！",
        // 		type: "warning",
        // 	});
        // 	return;
        // }
        this.remoteDeviceListOptFor = item;
        this.$forceUpdate();
      }
      // this.remoteDeviceListOptFor = item;
    },
    getFertilizerDevice() {
      //水肥设备
      this.fertilizerDeviceList = [];
      this.onlineNum = 0;
      this.offlineNum = 0;
      let httpData = {
        hothouseDeviceMid: "",
        pageNum: 1,
        pageSize: 10,
        deptId: this.userInfo ? this.userInfo.deptId : 0,
        // deptId: 141,
        fertilizerDeviceMid: this.parkId,
      };
      this.$axios
        .get("/fertilizerDevice/list", {
          params: httpData,
        })
        .then((data) => {
          console.log("查水肥设备---fertilizerDevice---res", data);
          if (data.msg == "设备繁忙中，请稍后再试：有设备正在运行指令！") {
            let httpDatas = {
              deviceId: this.fertilizerDeviceListOptFor.fertilizerDeviceNumber,
            };
            console.log("clearQueue-清空后重查---httpData", httpData);
            this.$axios
              .post("/DeviceMqttPushApi/clearQueue", {
                params: httpDatas,
              })
              .then((res) => {
                console.log("clearQueue-清空后重查---", res);
                this.getFertilizerDevice();
              })
              .catch((error) => {
                console.log("clearQueue-error---", error);
              });
          }

          let res = data.data;
          for (let i in res) {
            this.fertilizerDeviceList.push(res[i]);
            if (res[i].fertilizerDeviceState != 2) {
              this.offlineNum += 1;
            } else {
              this.onlineNum += 1;
            }
          }
          if (this.fertilizerDeviceList.length != "0") {
            // 数据不为空时，默认选中在线第一个
            for (let i = 0; i < this.fertilizerDeviceList.length; i++) {
              if (this.fertilizerDeviceList[i].fertilizerDeviceState == 2) {
                this.fertilizerDeviceListOptFor = this.fertilizerDeviceList[i];
                // console.log('this.fertilizerDeviceListOptFor赋值成功', this.fertilizerDeviceListOptFor)
                this.$forceUpdate();
                break;
              }
            }
          }
          this.getFiveEchart();
          this.getOneEchart();
          this.getTwoEchart();
          this.getThreeEchart();
        })
        .catch((error) => {
          console.log("---fertilizerDevice---error===", error);
        });
    },
    getNextDay(dateString) {
      // console.log('--getNextDay--', dateString)
      // 创建一个日期对象
      var date = new Date(dateString);
      // 获取当前日期的毫秒数
      var milliseconds = date.getTime();
      // 将毫秒数增加一天的毫秒数
      milliseconds += 24 * 60 * 60 * 1000;
      // 创建一个新的日期对象，使用增加后的毫秒数
      var nextDay = new Date(milliseconds);
      // 获取新日期的年、月、日
      var year = nextDay.getFullYear();
      var month = nextDay.getMonth() + 1; // 月份从0开始，需要加1
      var day = nextDay.getDate() - 1;
      var hour = nextDay.getHours();
      var minute = nextDay.getMinutes();
      var formattedDate =
        year +
        "-" +
        month.toString().padStart(2, "0") +
        "-" +
        day.toString().padStart(2, "0") +
        " " +
        hour.toString().padStart(2, "0") +
        ":" +
        minute.toString().padStart(2, "0");
      // 格式化日期为YYYY-MM-DD hh:mm的形式
      // console.log('日历----', formattedDate)
      return formattedDate;
    },
    getFiveEchart() {
      if (this.powerInfo) {
        var region = this.powerInfo.powerWaterRegion1.split(",");
        var regionName = this.powerInfo.powerWaterRegion1Name.split(",");
        var regionUnit = this.powerInfo.powerWaterRegion1Unit.split(",");
        console.log("region", region);
      }
      //土壤湿度统计图
      let httpData = {
        seachType: 0,
        time: this.nowTime,
        dataType: this.powerInfo ? region[0] : "0002",
        deviceAddr: this.fertilizerDeviceListOptFor.fertilizerDeviceNumber, //"SF000001", //设备ID
        // deviceAddr: "SF000023",
      };
      console.log("土壤湿度-echart---httpData", httpData);
      this.$axios
        .get("/data", {
          params: httpData,
        })
        .then((res) => {
          console.log("土壤湿度-echart---res", res);
          let sdArr = [];
          for (let i in res.data) {
            sdArr.push(res.data[i].y);
          }
          httpData.dataType = this.powerInfo ? region[1] : "0000";
          this.$axios
            .get("/data", {
              params: httpData,
            })
            .then((data) => {
              console.log("土壤温度-echart---data", data);
              let wdArr = [];
              let xData = [];
              for (let i in data.data) {
                wdArr.push(data.data[i].y);
                let xDataHour = data.data[i].x.substring(
                  data.data[i].x.length - 5,
                  data.data[i].x.length
                );
                // xData.push(xDataHour);
                xData.push(xDataHour);
              }

              var dom = document.getElementById("main1");
              var myChart = echarts.init(dom, null, {
                renderer: "canvas",
                useDirtyRect: false,
              });

              var option;

              option = {
                tooltip: {
                  trigger: "axis",
                },
                color: ["#00DEFF", "#FFAA00"],
                legend: {
                  data: regionName,
                  textStyle: {
                    color: "#fff",
                  },
                },
                xAxis: [
                  {
                    type: "category",
                    data: xData,
                    axisPointer: {
                      type: "shadow",
                    },
                    axisLabel: {
                      textStyle: {
                        color: "#FFFFFF",
                      },
                    },
                  },
                ],
                yAxis: [
                  {
                    type: "value",
                    name: "单位：" + regionUnit[0],
                    axisLabel: {
                      textStyle: {
                        color: "#FFFFFF",
                      },
                    },
                  },
                  {
                    type: "value",
                    name: "单位：" + regionUnit[1],
                    axisLabel: {
                      textStyle: {
                        color: "#FFFFFF",
                      },
                    },
                  },
                ],
                series: [
                  {
                    name: "温度",
                    type: "bar",
                    data: wdArr,
                    showBackground: true,
                    backgroundStyle: {
                      color: "rgba(180, 180, 180, 0.2)",
                    },
                    tooltip: {
                      valueFormatter: function (value) {
                        return value + regionUnit[0];
                      },
                    }
                  },
                  {
                    name: "湿度",
                    type: "line",
                    yAxisIndex: 1,
                    data: sdArr,
                    tooltip: {
                      valueFormatter: function (value) {
                        return value + regionUnit[1];
                      },
                    }
                  },
                ],
              };

              if (option && typeof option === "object") {
                myChart.setOption(option);
              }
              window.addEventListener("resize", myChart.resize);
            })
            .catch((error2) => {
              console.log("土壤温度-echart---error===", error2);
            });
        })
        .catch((error) => {
          console.log("土壤湿度-echart---error===", error);
        });
    },
    getOneEchart() {
      if (this.powerInfo) {
        var region = this.powerInfo.powerWaterRegion3.split(",");
        var regionUnit = this.powerInfo.powerWaterRegion3Unit ? this.powerInfo.powerWaterRegion3Unit.split(",") : [""];
        console.log("region", region);
      }
      let httpData = {
        seachType: 0,
        time: this.nowTime,
        dataType: this.powerInfo ? region[0] : "0010",
        deviceAddr: this.fertilizerDeviceListOptFor.fertilizerDeviceNumber, //"SF000001", //设备ID
        // deviceAddr: "SF000023",
      };
      this.$axios
        .get("/data", {
          params: httpData,
        })
        .then((data) => {
          console.log("水肥PH-echart---res", data);
          let PHArr = [];
          let xData = [];
          for (let i in data.data) {
            PHArr.push(data.data[i].y);
            let xDataHour = data.data[i].x.substring(
              data.data[i].x.length - 5,
              data.data[i].x.length
            );
            // xData.push(xDataHour);
            xData.push(xDataHour);
          }
          var dom3 = document.getElementById("main3");
          var myChart3 = echarts.init(dom3, null, {
            renderer: "canvas",
            useDirtyRect: false,
          });

          var option;
          option = {
            tooltip: {
              trigger: "axis",
            },
            color: "#00DCFE",
            xAxis: {
              type: "category",
              data: xData,
              axisLabel: {
                textStyle: {
                  color: "#FFFFFF",
                },
              },
            },
            yAxis: {
              type: "value",
              name: "单位：" + regionUnit[0],
              axisLabel: {
                textStyle: {
                  color: "#FFFFFF",
                },
              },
            },
            series: [
              {
                data: PHArr,
                type: "line",
                tooltip: {
                  valueFormatter: function (value) {
                    return value + regionUnit[0];
                  },
                }
              },
            ],
          };

          if (option && typeof option === "object") {
            myChart3.setOption(option);
          }
          window.addEventListener("resize", myChart3.resize);
        })
        .catch((error) => {
          console.log("水肥PH-echart---error===", error);
        });
    },
    getTwoEchart() {
      if (this.powerInfo) {
        var region = this.powerInfo.powerWaterRegion2.split(",");
        var regionUnit = this.powerInfo.powerWaterRegion2Unit.split(",");
        console.log("region", region);
      }
      let httpData = {
        seachType: 0,
        time: this.nowTime,
        // dataType: "0012",
        dataType: this.powerInfo ? region[0] : "0012",
        deviceAddr: this.fertilizerDeviceListOptFor.fertilizerDeviceNumber, //"SF000001", //设备ID
        // deviceAddr: "SF000023",
      };
      this.$axios
        .get("/data", {
          params: httpData,
        })
        .then((data) => {
          console.log("水肥EC-echart---res", data);
          let ECArr = [];
          let xData = [];
          for (let i in data.data) {
            ECArr.push(data.data[i].y);
            let xDataHour = data.data[i].x.substring(
              data.data[i].x.length - 5,
              data.data[i].x.length
            );
            // xData.push(xDataHour);
            xData.push(xDataHour);
          }
          var dom2 = document.getElementById("main2");
          var myChart2 = echarts.init(dom2, null, {
            renderer: "canvas",
            useDirtyRect: false,
          });

          var option;
          option = {
            tooltip: {
              trigger: "axis",
            },

            color: "#00DCFE",
            xAxis: {
              type: "category",
              data: xData,
              axisLabel: {
                textStyle: {
                  color: "#FFFFFF",
                },
              },
            },
            yAxis: {
              type: "value",
              name: "单位：" + regionUnit[0],
              axisLabel: {
                textStyle: {
                  color: "#FFFFFF",
                },
              },
            },
            series: [
              {
                data: ECArr,
                type: "line",
                tooltip: {
                  valueFormatter: function (value) {
                    return value + regionUnit[0];
                  },
                }
              },
            ],
          };

          if (option && typeof option === "object") {
            myChart2.setOption(option);
          }
          window.addEventListener("resize", myChart2.resize);
        })
        .catch((error) => {
          console.log("水肥EC-echart---error===", error);
        });
    },
    getThreeEchart() {
      if (this.powerInfo) {
        var region = this.powerInfo.powerWaterRegion4.split(",");
        var regionUnit = this.powerInfo.powerWaterRegion4Unit.split(",");
        console.log("region", region);
      }
      let httpData = {
        seachType: 0,
        time: this.nowTime,
        dataType: this.powerInfo ? region[0] : "0040",
        // deviceAddr: this.fertilizerDeviceListOptFor.fertilizerDeviceNumber, //"SF000001", //设备ID
        deviceAddr: "SF000023",
        // dataType: "0040",
        // deviceAddr: this.fertilizerDeviceListOptFor.fertilizerDeviceNumber, //"SF000001", //设备ID
      };
      this.$axios
        .get("/data", {
          params: httpData,
        })
        .then((data) => {
          console.log("水肥总管压力echart---res", data);
          let ECArr = [];
          let xData = [];
          for (let i in data.data) {
            ECArr.push(data.data[i].y);
            let xDataHour = data.data[i].x.substring(
              data.data[i].x.length - 5,
              data.data[i].x.length
            );
            // xData.push(xDataHour);
            xData.push(xDataHour);
          }
          var dom4 = document.getElementById("main4");
          var myChart4 = echarts.init(dom4, null, {
            renderer: "canvas",
            useDirtyRect: false,
          });

          var option;
          option = {
            tooltip: {
              trigger: "axis",
            },
            color: "#00DCFE",
            xAxis: {
              type: "category",
              data: xData,
              axisLabel: {
                textStyle: {
                  color: "#FFFFFF",
                },
              },
            },
            yAxis: {
              type: "value",
              name: "单位：" + regionUnit[0],
              axisLabel: {
                textStyle: {
                  color: "#FFFFFF",
                },
              },
            },
            series: [
              {
                data: ECArr,
                type: "line",
                tooltip: {
                  valueFormatter: function (value) {
                    return value + regionUnit[0];
                  },
                }
              },
            ],
          };

          if (option && typeof option === "object") {
            myChart4.setOption(option);
          }
          window.addEventListener("resize", myChart4.resize);
        })
        .catch((error) => {
          console.log("水肥总管压力-echart---error===", error);
        });
    },
  },
};
</script>

<style scoped>
ul li {
  list-style: none;
}

.box_sum {
  background: url("https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702719790626.png");
  background-size: 100% 100%;
  width: 280px;
  height: 200px;
  text-align: center;
}

.box_sum p {
  font-size: 30px;
  font-weight: bold;
  color: #ffffff;
  padding-top: 40px;
}

.box_online {
  background: url("https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702719269865.png");
  background-size: 100% 100%;
  width: 282px;
  height: 100px;
  display: flex;
  align-items: center;
}

.box_online p {
  font-size: 20px;
  color: #ffffff;
  margin: 0 16px 0 100px;
}

.box_online b {
  background: linear-gradient(0deg, #00beda 32%, #00ffc6 79%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-size: 36px;
}

.title-img {
  width: 100%;
  height: 40px;
  background-image: url("https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704181612497.png");
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
}

.title-img-tab div {
  width: 50%;
  text-align: center;
  line-height: 33px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 6px;
}

#title-img-tab1 {
  background: #2c83ef;
}

.title-img-tab {
  background: rgba(44, 131, 239, 0.2);
  width: 260px;
  height: 33px;
  border-radius: 6px;
  display: flex;
  margin-top: -5px;
}

.title {
  padding-left: 30px;
  position: relative;
  top: -8px;
}

.state-bg {
  width: 100%;
  height: 270px;
  background-image: url("https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704181399133.png");
  background-size: 100% 100%;
  margin-bottom: 20px;
}

.list-bg {
  width: 100%;
  height: 535px;
  background-image: url("https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704181399133.png");
  background-size: 100% 100%;
  color: #a8ccde;
  padding-top: 30px;
}

.water-list-body-item {
  padding: 0px 15px 15px 20px;
  height: 467px;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  background: rgba(176, 218, 239, 0.05);
}

.water-list-body-item>div {
  background: rgba(176, 218, 239, 0.05);
  width: 100%;
  margin-top: 10px;
}

.water-list-body-item::-webkit-scrollbar {
  width: 8px;
  background-color: transparent;
}

.water-list-bodyitem::-webkit-scrollbar-thumb {
  background-color: transparent;
}

.water-list-body-item-bg {
  background: rgba(24, 254, 240, 0.2);
  color: #18fef0;
}

.center-top-img {
  width: 55%;
  height: 400px;
}

.center-top-list {
  width: 43%;
  display: flex;
  justify-content: space-between;
}

.center-top-list b {
  font-size: 20px;
  color: #ffffff;
}

.center-top-list p {
  font-size: 18px;
  color: #a5c9ff;
  margin-top: 10px;
}

.center-top-list span {
  font-size: 15px;
  color: #a5c9ff;
  margin-top: 10px;
}

.center-top-list>div {
  width: 22%;
  height: 400px;
  background: #294375;
  border-radius: 10px;
  /* padding: 30px 0; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.center-top-list ul li {
  padding: 15px;
}

ul {
  padding-inline-start: 0;
  text-align: center;
}

.chart-bg {
  width: 50%;
  height: 100%;
  padding: 15px 0px 0px 0px;
  background-image: url("https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704181399133.png");
  background-size: 100% 100%;
}

.center-chart1 {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chart-title {
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
}

.title1-img {
  width: 100%;
  height: 40px;
  background-image: url("https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704183078849.png");
  background-size: 100% 100%;
}

.titles {
  display: flex;
  justify-content: flex-end;
  padding-right: 30px;
  position: relative;
  top: -10px;
  font-size: 20px;
  font-weight: 600;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.data-count {
  display: flex;
  justify-content: flex-start;
  align-content: center;
}

.data-sum-count {
  width: 150px;
  height: 210px;
  padding: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
